<div class="table">
  <div class="table-header">
    <span class="column" *ngFor="let column of columns">{{ column }}</span>
  </div>
  <div class="table-body">
    <ng-content></ng-content>
  </div>
</div>
